module.exports = __webpack_public_path__ + "static/media/gpay.977de07c.svg";